import type { HelpContent } from './entries.tr';
import type { AI_HELP_TR } from './entries.ai';

type Loc = Pick<HelpContent, 'title' | 'short'>;

/**
 * Faz 9 (yapay zekâ, öneri motoru, talep tahmini) yardım başlıkları ve kısa açıklamaları — Arapça. Ayrıntı alanları
 * Türkçe kayda düşer (Faz 8 düzeniyle aynı). Terimler: docs/I18N_GLOSSARY.md.
 */
export const AI_HELP_AR: Record<keyof typeof AI_HELP_TR, Loc> = {
  'page.ai_settings': {
    title: 'إعدادات الذكاء الاصطناعي',
    short: 'تفعيل الذكاء الاصطناعي وإيقافه، وحد الإنفاق الشهري، والنماذج، وجدول الأسعار، وتقرير الاستخدام.',
  },
  'ai.enable': {
    title: 'تفعيل الذكاء الاصطناعي',
    short: 'تحدد حد الإنفاق الشهري وتؤكد أنك تفعّل خدمة مدفوعة. بعد ذلك فقط تُرسل الطلبات إلى المزوّد.',
  },
  'ai.disable': {
    title: 'إيقاف الذكاء الاصطناعي',
    short: 'لا تُرسل طلبات جديدة؛ وتُحفظ الإعدادات وسجل الاستخدام.',
  },
  'ai.limits': {
    title: 'حدود الإنفاق والطلبات',
    short:
      'الحد الشهري هو الإنفاق التقديري بالدولار الأمريكي (USD)، والحد اليومي هو عدد الطلبات. عند بلوغ أيٍّ منهما تعرض الأزرار «تم بلوغ الحد».',
  },
  'ai.models': {
    title: 'النماذج',
    short:
      'نموذج النصوص للنصوص الطويلة، ونموذج أرخص للمهام القصيرة مثل العناوين والأوصاف التعريفية والنصوص البديلة، ونموذج الصور للصور.',
  },
  'ai.prices': {
    title: 'جدول الأسعار',
    short:
      'سعر الإدخال والإخراج لكل مليون token (USD). أُخذت القيم الافتراضية من صفحات أسعار المزوّدين؛ حدّثها إذا تغيّرت.',
  },
  'ai.usage': {
    title: 'تقرير الاستخدام',
    short:
      'كل طلب أُرسل إلى المزوّد: الغرض، والنموذج، والنتيجة، وعدد الـ token، والتكلفة التقديرية، والمستخدم، وعدد البيانات الشخصية المُخفاة والادعاءات الصحية.',
  },
  'ai.supportDrafts': {
    title: 'رسالة العميل في مسودات الدعم',
    short:
      'عند التفعيل تُرسل رسالة العميل إلى الذكاء الاصطناعي بعد إخفاء بياناتها الشخصية لإعداد مسودة رد الدعم. متوقف افتراضيًا.',
  },
  'page.ai_recommendations': {
    title: 'توصيات المنتجات',
    short:
      'إعدادات ونتائج أقسام «من اشترى هذا المنتج اشترى أيضًا» وتوصيات السلة و«حان وقت إعادة الشراء» في حسابي.',
  },
  'recommendations.run': {
    title: 'احسب الآن',
    short: 'يعيد حساب التوصيات دون انتظار المهمة الليلية (تُحذف العلاقات القديمة وتُكتب الجديدة).',
  },
  'recommendations.pairs': {
    title: 'أقوى العلاقات',
    short:
      'أقوى علاقة لكل منتج: عدد المشترين المختلفين، والثقة (نسبة مشتري المنتج الذين اشتروا الآخر أيضًا)، والرفع (كم مرة يتكرر الشراء المشترك أكثر من المصادفة).',
  },
  'recommendations.settings': {
    title: 'إعدادات التوصيات',
    short:
      'تفعيل الأقسام وإيقافها، والفترة المحلَّلة، والحد الأدنى للمشترين المختلفين (للخصوصية)، والحد الأدنى للثقة، والحد الأقصى للتوصيات لكل منتج، وطلبات الموزّعين.',
  },
  'page.ai_forecast': {
    title: 'توقع الطلب',
    short:
      'المبيعات المتوقعة لكل متغير منتج، وعدد الأيام التي يكفيها المخزون الحالي، وكمية الطلب المقترحة، وخطر انتهاء الصلاحية.',
  },
  'forecast.accuracy': {
    title: 'خطأ التوقع (WAPE)',
    short:
      'مقدار انحراف التوقع المبني على بيانات ما قبل أربعة أسابيع عن المبيعات الفعلية في الأسابيع الأربعة الأخيرة (إجمالي الانحراف ÷ إجمالي المبيعات). كلما قلّ كان أفضل.',
  },
  'forecast.table': {
    title: 'قائمة التوقعات',
    short:
      'تظهر أولًا المنتجات النافدة وتلك التي حان وقت طلبها. عبر «ضبط» تُدخل مدة توريد وأيام أمان خاصة بالمنتج أو تستبعده من التوقع.',
  },
  'forecast.on_order': {
    title: 'قيد التوريد',
    short:
      'الكمية التي لم تُستلم بعد من أوامر الشراء المرسلة إلى المورّدين، وتحتها كمية الطلبات التي لم تُرسل بعد. تُخصم كلتاهما من الكمية المقترحة. تؤخذ مدة التوريد من آخر مورّد ما لم تُحدَّد مدة خاصة بالمنتج.',
  },
  'forecast.settings': {
    title: 'الإعدادات الافتراضية للتوقع',
    short:
      'السجل المحلَّل، ومدة التوريد وأيام الأمان الافتراضية، وفترة المراجعة، وحد المخزون الزائد، وطلبات الموزّعين.',
  },
  'page.content_studio': {
    title: 'استوديو المحتوى',
    short:
      'إعداد المقالات عبر عملية من 27 خطوة: من الموضوع والمصادر إلى المخطط، ومن المسودة إلى SEO والصور وفحص الجودة.',
  },
  'page.content_studio_project': {
    title: 'مشروع مقال',
    short: 'الخطوات الـ27 لمقال واحد: يظهر في الأعلى ما اكتمل منها وما استُخدم فيه الذكاء الاصطناعي.',
  },
  'studio.create': {
    title: 'مشروع مقال جديد',
    short:
      'يفتح مشروعًا جديدًا بالموضوع والجمهور المستهدف واللغة والدولة والكلمة المفتاحية ونية البحث. لا يتغير شيء في المدونة.',
  },
  'studio.brief': {
    title: 'الموضوع والهدف',
    short:
      'السؤال الذي يجيب عنه المقال، ولمن يُكتب، والدولة المستهدفة، ونية البحث. تعتمد اقتراحات الذكاء الاصطناعي على هذه المعلومات.',
  },
  'studio.keyword': {
    title: 'الكلمة المفتاحية',
    short:
      'عملية البحث التي يستهدفها المقال. إذا اختيرت من مجمّع الكلمات المفتاحية تُؤخذ نية البحث منه أيضًا.',
  },
  'studio.health': {
    title: 'محتوى صحي / مكمّلات غذائية',
    short: 'عند تحديده تصبح المصادر إلزامية، ولا يمكن نشر مقال المدونة دون اعتماد المراجع البيطري المختص.',
  },
  'studio.save': {
    title: 'حفظ',
    short: 'يحفظ تغييرات المشروع. إذا حفظه شخص آخر في الوقت نفسه يظهر تحذير؛ حدّث الصفحة وأعد المحاولة.',
  },
  'studio.steps': {
    title: '27 خطوة',
    short:
      'تُحسب حالة كل خطوة من البيانات الفعلية المحفوظة؛ ويشير رمز النجمة إلى استخدام الذكاء الاصطناعي في تلك الخطوة.',
  },
  'studio.sources': {
    title: 'المصادر',
    short:
      'المصادر التي يستند إليها المقال (20 كحد أقصى). لا يجوز للذكاء الاصطناعي الاستشهاد إلا بها بصيغة [1] و[2]؛ ولا يمكنه اختلاق مصادر.',
  },
  'studio.verify': {
    title: 'التحقق من المصادر',
    short:
      'يفتح الخادم كل مصدر: هل يمكن الوصول إليه، وإلى أين يُعاد توجيهه، وما عنوان الصفحة. لا يُحفظ المحتوى، وتُحظر عناوين الشبكة الداخلية.',
  },
  'studio.duplicates': {
    title: 'فحص التكرار',
    short:
      'يقارن تشابه العنوان مع مقالات المدونة وصفحات المتجر باللغة نفسها (بصرف النظر عن الأحرف التركية). ما يزيد على 60% تحذير.',
  },
  'studio.ai_plan': {
    title: 'المخطط والعناوين بالذكاء الاصطناعي',
    short:
      'يقترح مخططًا قصيرًا وعناوين H2/H3 بناءً على الموضوع والجمهور والكلمة المفتاحية وقائمة المصادر. طلب مدفوع يُحتسب ضمن الحد الشهري.',
  },
  'studio.ai_draft': {
    title: 'مسودة بالذكاء الاصطناعي',
    short:
      'يكتب مسودة Markdown وفق العناوين، لذا يلزم وجود العناوين أولًا. وإذا عُثر على ادعاءات صحية تُعرض في الشاشة.',
  },
  'studio.draft': {
    title: 'المسودة',
    short:
      'Markdown: ## لعناوين H2، و### لعناوين H3، و[النص](/urun/slug) للروابط الداخلية. تُحوَّل عند النقل إلى مستند المدونة؛ ولا يُنفَّذ كود HTML الخام.',
  },
  'studio.links': {
    title: 'الروابط الداخلية',
    short:
      'تُقترح المنتجات والفئات والمقالات المنشورة المطابقة للموضوع (بلا ذكاء اصطناعي). وتُمرَّر الروابط المختارة إلى مسودة الذكاء الاصطناعي كروابط مرشّحة.',
  },
  'studio.related': {
    title: 'منتجات ذات صلة',
    short: 'منتجات تُعرض أسفل مقال المدونة (8 كحد أقصى). تنتقل إلى المقال عند النقل.',
  },
  'studio.ai_meta': {
    title: 'اقتراح SEO بالذكاء الاصطناعي',
    short: 'يقترح عنوان SEO والوصف التعريفي والاسم المختصر والوسوم (بنموذج المهام القصيرة الأرخص).',
  },
  'studio.seo': {
    title: 'حقول SEO',
    short:
      'عنوان SEO بحد أقصى 70 حرفًا، والوصف التعريفي بحد أقصى 170 حرفًا. يتكون الاسم المختصر من أحرف صغيرة وأرقام وشرطات.',
  },
  'studio.images': {
    title: 'الصور',
    short:
      'تُنقل صورة الغلاف ونصها البديل إلى مقال المدونة. يجب أن يكون لكل صورة نص بديل (لإمكانية الوصول وSEO).',
  },
  'studio.quality': {
    title: 'فحص الجودة',
    short:
      'طول العنوان والوصف، وعدد الكلمات، وبنية العناوين، والكلمة المفتاحية، والروابط الداخلية، والمصادر، والنصوص البديلة للصور، والادعاءات الصحية، والتكرار.',
  },
  'studio.export': {
    title: 'نقل إلى مقال المدونة',
    short:
      'ينشئ مسودة جديدة في المدونة أو يحدّث مسودة المقال المرتبط. لا يتغير المقال المنشور؛ ويتم النشر من شاشة المدونة.',
  },
  'studio.disclosure': {
    title: 'ملاحظة المساعدة بالذكاء الاصطناعي',
    short:
      'إذا استُخدم الذكاء الاصطناعي في خطوة المخطط أو المسودة أو SEO تُضاف في نهاية المقال ملاحظة «أُعدّ بمساعدة الذكاء الاصطناعي». مفعّلة افتراضيًا.',
  },
  'studio.archive': {
    title: 'أرشفة المشروع',
    short: 'يُزال المشروع من القائمة ولا يمكن تغييره. لا يتأثر مقال المدونة المرتبط.',
  },
  'studio.performance': {
    title: 'الأداء',
    short:
      'بيانات Search Console للمقال المنشور في آخر 28 يومًا والـ28 يومًا السابقة: النقرات ومرات الظهور ونسبة النقر إلى الظهور ومتوسط الترتيب وعمليات البحث.',
  },
  'studio.suggestions': {
    title: 'اقتراحات التحديث',
    short:
      'اقتراحات قائمة على قواعد: مقال لم يُحدَّث منذ عام، وانخفاض الزيارات، ونسبة نقر منخفضة، وترتيب قريب من الصفحة الأولى، وعمليات بحث لا يغطيها المقال، وتحقق قديم من المصادر.',
  },
  'studio.ai_cover': {
    title: 'صورة غلاف بالذكاء الاصطناعي',
    short:
      'ينشئ صورة غلاف أصلية وفق وصفك (OpenAI Images). طلب مدفوع؛ والحد الأعلى لكل صورة محدد في الإعدادات.',
  },
  'studio.ai_image': {
    title: 'صورة محتوى بالذكاء الاصطناعي',
    short:
      'ينشئ صورة أصلية لاستخدامها داخل المقال ويضيفها إلى صور المحتوى (20 كحد أقصى). ضعها في النص عبر «إضافة إلى المسودة».',
  },
  'studio.ai_alt': {
    title: 'نص بديل بالذكاء الاصطناعي',
    short:
      'تُعرض الصورة على نموذج المهام القصيرة ويُقترح نص بديل من جملة واحدة للقرّاء ذوي الإعاقة البصرية. يملأ الحقل؛ راجعه قبل الحفظ.',
  },
  'studio.provenance': {
    title: 'المصدر والترخيص',
    short:
      'مصدر الصورة التي رفعتها (تصويرك الخاص، صورة مرخّصة من مكتبة صور، المورّد)، وترخيصها، وحقوق النشر/الإسناد، ورابط المصدر. لا يمكن تغيير مصدر الصورة المُنشأة بالذكاء الاصطناعي.',
  },
  'studio.insert_image': {
    title: 'إضافة إلى المسودة',
    short:
      'يضيف الصورة سطرًا في نهاية المسودة؛ انقل السطر إلى الموضع الذي تريده في النص. وعند النقل تظهر الصورة في ذلك الموضع من مقال المدونة.',
  },
  'ai.draft_product': {
    title: 'مسودة وصف بالذكاء الاصطناعي',
    short:
      'يكتب مسودة وصف قصير وطويل من البيانات المحفوظة للمنتج (الاسم، العلامة التجارية، نوع الحيوان، الفئة، الخصائص، التركيب، الاستخدام، التحذيرات). لا يختلق معلومات، وينبّه إذا وُجدت ادعاءات صحية.',
  },
  'ai.draft_translate': {
    title: 'ترجمة بالذكاء الاصطناعي',
    short:
      'يترجم مسودة المقال المقابل باللغة التي تختارها إلى لغة هذا المقال: العنوان والملخص وحقول SEO والنص. تُحفظ الروابط والصور والبنية.',
  },
  'ai.draft_email': {
    title: 'اقتراح موضوع بالذكاء الاصطناعي',
    short:
      'يقترح ثلاثة أسطر موضوع ونصًا تمهيديًا وفقرة مقدمة وفق هدف الحملة. لا يختلق إلحاحًا ويتجنب عبارات الرسائل المزعجة.',
  },
  'ai.draft_support': {
    title: 'مسودة رد بالذكاء الاصطناعي',
    short:
      'يكتب مسودة رد من موضوع التذكرة وفئتها وحالة الطلب وآخر الرسائل. لا يظهر ما لم يفعّله المالك من الإعدادات.',
  },
  'ai.ad_suggestions': {
    title: 'توصيات الإعلانات',
    short:
      'نتائج قائمة على قواعد لكل حملة: إنفاق بلا طلبات، وROAS أقل من 1، ونسبة نقر منخفضة، وحملة قابلة للتوسيع، وحالات شاذة. ويرتّب «تلخيص بالذكاء الاصطناعي» النتائج حسب الأولوية بالاعتماد على هذه الأرقام فقط.',
  },
  'ai.draft_ad_copy': {
    title: 'مسودة نص إعلاني',
    short:
      'نصوص إعلان بحث متجاوب على Google (العنوان ≤ 30 حرفًا، والوصف ≤ 90 حرفًا) أو إعلان Meta للمنتج المختار. تُسقط الأسطر التي تتجاوز الحد.',
  },
  'page.ai_copilot': {
    title: 'Copilot (مساعد الأعمال)',
    short:
      'رؤى محسوبة من بيانات المبيعات والهامش والمرتجعات والمخزون وSEO وشرائح العملاء والإعلانات، ومساعد يجيب بهذه البيانات.',
  },
  'copilot.insights': {
    title: 'الرؤى',
    short:
      'مقارنة الفترة المختارة بالفترة السابقة المماثلة ونتائج قائمة على قواعد (الإيرادات، متوسط قيمة الطلب، المنتجات المسهمة في الانخفاض، المرتجعات، الهامش، الأيام بلا طلبات، المخزون، SEO، الشرائح، الإعلانات).',
  },
  'copilot.report': {
    title: 'نسخ كتقرير للإدارة',
    short: 'ينسخ الرؤى نقطةً نقطةً كنص عادي إلى الحافظة (للصقها في بريد إلكتروني أو رسالة).',
  },
  'copilot.ask': {
    title: 'اسأل Copilot',
    short:
      'يرسل السؤال وحزمة البيانات المحسوبة إلى المزوّد للحصول على إجابة قصيرة ومحددة. طلب مدفوع؛ ولا ينفّذ أي إجراء.',
  },
  'copilot.profit': {
    title: 'صافي الربح',
    short:
      'حساب الربحية في التقرير المالي (دون الضريبة، بالليرة التركية) لهذه الفترة والفترة السابقة؛ يظهر فقط لمن لديه صلاحية التقرير المالي.',
  },
  'page.ai_seo': {
    title: 'اقتراحات SEO',
    short:
      'عناقيد الكلمات المفتاحية، وخريطة المواضيع، وعمليات البحث الطويلة (Long-tail)، وفجوات المحتوى، وعناوين منتجات Google.',
  },
  'seo_ai.clusters': {
    title: 'العناقيد التلقائية',
    short:
      'تُقترح في عنقود واحد الكلمات التي تتداخل جذورها بنسبة النصف على الأقل (أو يتضمن بعضها بعضًا)؛ واسم العنقود هو الكلمة الأعلى ظهورًا. يُطبَّق ما تختاره على المجمّع.',
  },
  'seo_ai.topics': {
    title: 'خريطة المواضيع',
    short:
      'الكلمة الرئيسية لكل عنقود وصفحتها المحورية (Pillar)، والمحتوى الداعم، وما إذا كان مقال المدونة الداعم يرتبط بالصفحة المحورية.',
  },
  'seo_ai.long_tail': {
    title: 'عمليات البحث الطويلة (Long-tail)',
    short:
      'عمليات بحث Search Console غير الموجودة في المجمّع، المكوّنة من 3 كلمات فأكثر والتي حققت 10 مرات ظهور فأكثر؛ وتُقدَّر نية البحث من صياغتها.',
  },
  'seo_ai.gaps': {
    title: 'فجوات المحتوى',
    short:
      'كلمات المجمّع التي ليس لها صفحة مستهدفة. يفتح «إنشاء مشروع مقال» مشروعًا مرتبطًا بالكلمة في استوديو المحتوى.',
  },
  'seo_ai.merchant_titles': {
    title: 'عناوين منتجات Google',
    short:
      'تُفحص قواعد العنوان ويُقدَّم اقتراح قائم على القواعد (العلامة التجارية + اسم المنتج + النوع + الكمية). ويُنشئ «عنوان بالذكاء الاصطناعي» اقتراحًا مدفوعًا؛ ولا يُحفظ أيٌّ منها دون موافقتك.',
  },
  'page.ai_ltv': {
    title: 'القيمة المتوقعة للعميل',
    short:
      'الإنفاق المتوقع للعملاء خلال الأشهر الـ12 القادمة (LTV)، والمتوسطات حسب الشريحة، والعملاء الأعلى قيمة، ومقارنة بتكلفة الاكتساب عبر الإعلانات.',
  },
  'ltv.model': {
    title: 'النموذج',
    short:
      'التوقع تقدير وليس قيمة مؤكدة: لا يُراعى أثر المواسم والحملات وتغيّر الأسعار. يلزم 20 عميلًا على الأقل للتوقع لدى العملاء ذوي الطلب الواحد.',
  },
  'ltv.segments': {
    title: 'حسب الشريحة',
    short:
      'متوسط الإنفاق السابق والإنفاق المتوقع خلال 12 شهرًا لكل شريحة RFM: يبيّن الشريحة التي يُستحسن الاستثمار فيها.',
  },
  'page.ai_youtube': {
    title: 'مقاطع فيديو YouTube',
    short:
      'حالة مقاطع فيديو YouTube المستخدمة في المنتجات ومقالات المدونة (منشور، غير قابل للتضمين، محظور في تركيا، محذوف)، ومدتها، وقناتها، وأماكن استخدامها.',
  },
  'youtube.connection': {
    title: 'اتصال YouTube',
    short:
      'فعّل YouTube Data API v3 في Google Cloud وأنشئ مفتاح API (يُنصح بقيد IP)، ثم أدخله في التكاملات ← YouTube Data API واختبره. إذا لم يوجد مفتاح يظهر «يتطلب الإعداد»؛ وتُعرض مقاطع الفيديو في واجهة المتجر كما كانت.',
  },
  'youtube.sync': {
    title: 'المزامنة الآن',
    short:
      'تُقرأ معلومات مقاطع الفيديو المستخدمة من YouTube فورًا (وحدة حصة واحدة لكل 50 فيديو؛ والحصة اليومية المجانية 10,000). وتتم تلقائيًا كل ليلة في الساعة 05:50.',
  },
  'youtube.videos': {
    title: 'مقاطع الفيديو المستخدمة',
    short:
      'تُعرض مقاطع الفيديو ذات المشكلات أولًا. أزل الفيديو المحذوف أو غير القابل للتضمين من المنتج أو المقال المعني أو استبدله بفيديو آخر.',
  },
};
